import Box from '@mui/material/Box';
import AppInfoView from 'main/core/AppInfoView';
import {useUiWiseAppContext} from 'main/utility/AppContextProvider/UiWiseAppContextProvider';
import {generateRoutes} from 'main/utility/RouteGenerator';
import PropTypes from 'prop-types';
import {useMemo} from 'react';
import {useRoutes} from 'react-router-dom';
import {BUSINESS_ROLE} from '../../../shared/constants/AppConst';
import {useAuthUser} from '../../utility/AuthHooks';
import {normalizeRole} from '../../utility/helper/RouteHelper';
import AppErrorBoundary from '../AppErrorBoundary';
import AppFooter from '../AppLayout/components/AppFooter';
import AppSuspense from '../AppSuspense';
import AppContentViewWrapper from './AppContentViewWrapper';

const AppContentView = ({sxStyle}) => {
  const {user, isAuthenticated} = useAuthUser();
  const {uiWiseRoutes} = useUiWiseAppContext();

  const role = useMemo(() => {
    return normalizeRole(user?.role, BUSINESS_ROLE.PUBLIC);
  }, [user?.role]);

  const routes = useMemo(() => {
    return generateRoutes({
      isAuthenticated,
      userRole: role,
      customRoutes: uiWiseRoutes,
    });
  }, [isAuthenticated, role, uiWiseRoutes]);

  const appRoutes = useRoutes(routes);

  return (
    <AppContentViewWrapper>
      <AppInfoView />
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          p: {xs: 2, md: 3, xl: 6},
          ...sxStyle,
        }}
        className='app-content'
      >
        <AppSuspense>
          <AppErrorBoundary>{appRoutes}</AppErrorBoundary>
        </AppSuspense>
      </Box>
      <AppFooter />
    </AppContentViewWrapper>
  );
};

export default AppContentView;

AppContentView.propTypes = {
  sxStyle: PropTypes.object,
};
